import Dashboard from './pages/dashboard';
import { Routes, Route } from 'react-router';
import Login from 'pages/auth/Login';
import SignUp from 'pages/auth/SignUp';
import NotFound from 'pages/errors/NotFound';
import ForgotPassword from 'pages/auth/ForgotPassword';
import ResetPassword from 'pages/auth/ResetPassword';
import VerifyEmail from 'pages/auth/VerifyEmail';
import UserProfile from 'pages/dashboard/profile';
import Settings from 'pages/dashboard/settings';
import Chat from 'pages/dashboard/chat';
import CollectionHome from 'pages/dashboard/collections/CollectionHome';
import PublicCollection from 'pages/collection';
import Devices from 'pages/dashboard/devices';
import DeviceDetail from 'pages/dashboard/devices/DeviceDetail';
import DeviceAnalytics from 'pages/admin/device-analytics';

function App() {
  return (
    <Routes>
      <Route key={'dashboard'} path='/' element={<Dashboard />} />
      <Route key={'devices'} path='/devices' element={<Devices />} />
      <Route key={'device-detail'} path='/devices/:serialKey' element={<DeviceDetail />} />
      <Route key={'login'} path='/auth/login' element={<Login />} />
      <Route key={'signup'} path={'/auth/signup'} element={<SignUp />} />
      <Route key={'forgot-password'} path={'/auth/forgot-password'} element={<ForgotPassword />} />
      <Route
        key={'change-password'}
        path={'/auth/reset-password/:resetToken'}
        element={<ResetPassword />}
      />
      <Route
        key={'verify-email'}
        path={'/auth/verify-email/:verificationToken'}
        element={<VerifyEmail />}
      />
      <Route key={'account'} path='/account' element={<UserProfile />} />
      <Route key={'chat'} path='/chat' element={<Chat />} />
      <Route key={'settings'} path='/settings' element={<Settings />} />
      <Route key={'collections'} path='/collections' element={<CollectionHome />} />
      <Route key={'public-collection'} path='/public/:slug' element={<PublicCollection />} />
      <Route
        key={'admin-device-analytics'}
        path='/admin/device-analytics'
        element={<DeviceAnalytics />}
      />
      <Route key={'not-found'} path='*' element={<NotFound />} />
    </Routes>
  );
}

export default App;
